import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { finalize, map } from 'rxjs';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { CertificazioniService } from 'src/app/services/certificazioni/certificazioni.service';
import { SettoriService } from 'src/app/services/settori/settori.service';
import { DialogCreaCertificazioniComponent } from './dialog/dialog-crea-certificazioni/dialog-crea-certificazioni.component';
import { UtilityService } from 'src/app/services/utility/utility.service';
import {
  DialogImportazioneData,
  DialogImportazioneExcelComponent,
} from '../../analisi-materialita/stakeholder/dialog/dialog-importazione-excel/dialog-importazione-excel.component';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';

@Component({
  selector: 'app-cfg-certificazioni',
  templateUrl: './cfg-certificazioni.component.html',
  styleUrls: ['./cfg-certificazioni.component.scss'],
  standalone: false,
})
export class CfgCertificazioniComponent implements OnInit {
  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public filtri: Filtri[] = [
    {
      titolo: 'Nome',
      forControlName: 'nomeBreve',
      input: 'text',
    },
    {
      titolo: 'Descrizione',
      forControlName: 'descrizione',
      input: 'text',
    },
    {
      forControlName: 'settori',
      input: 'multiple-option',
      titolo: 'Settore',
      fnDatiOption: () =>
        this.settoriService.getSettori(0, 1000).pipe(map((value) => value?.content || [])),
      descValueOption: 'titolo',
      idValueOption: 'id',
      riempi: true,
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    nomeBreve: {
      title: 'Nome',
      value: 'nomeBreve',
      sortable: true,
    },
    descrizione: {
      title: 'Descrizione',
      value: 'descrizione',
      sortable: true,
    },
    settori: {
      title: 'Settori',
      value: (record: any) => record?.settori?.map((set: any) => set.titolo),
    },
    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
    },
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
    },
  };
  constructor(
    public dialog: MatDialog,
    private settoriService: SettoriService,
    private certificazioniService: CertificazioniService,
    private utilityService: UtilityService,
    public utenteService: UtenteService,
  ) {}

  ngOnInit(): void {}

  creaNuovo(cert?: any) {
    const dialogCreaImpegno = this.dialog.open(DialogCreaCertificazioniComponent, {
      data: {
        certificazioni: cert,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '95%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaImpegno.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    if (!sortBy) {
      sortBy = [
        {
          chiave: 'nomeBreve',
          sort: 'asc',
        },
      ];
    }

    return this.certificazioniService.getCert(page, pageSize, ricerca, filters, sortBy);
  };

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.creaNuovo(event.data);
        break;
      case 'elimina':
        this.elimina(event.data.id);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  elimina(idRiga: string) {
    this.utilityService.openDialog({
      descrizione: 'Confermi di eliminare la certificazione',
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.certificazioniService.deleteCert(idRiga).subscribe({
              next: (result: any) => {
                this.tabella.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabella.caricaDati();
                      },
                    },
                  ],
                });
              },
            });
          },
        },
      ],
    });
  }

  public importaCertificazioni() {
    const dialogImportaCertificazioni = this.dialog.open<
      DialogImportazioneExcelComponent,
      DialogImportazioneData
    >(DialogImportazioneExcelComponent, {
      data: {
        titoloImportazione: 'Importazione Certificazioni',
        subTitoloImportazione:
          'Scarica il file di template excel o fai una nuova importazione delle Certificazioni',
        tipoElemento: 'certificazione',
        azienda: false,
        nomeImport: 'certificazioni',
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      maxWidth: '90%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogImportaCertificazioni.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  /**
   * Metodo ti esportazione certificazioni
   */
  public exportCertificazioni() {
    this.spinnerOver.show();
    const filtri = this.tabella.getFilters;
    const ricerca = this.tabella.searchValue;

    this.certificazioniService
      .exportCertificazioni(ricerca, filtri)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          console.log(esito);
          if (esito.file) {
            this.utilityService.downloadExcel(esito.file, 'Exported_Certificazioni');
            this.utilityService.openSnackBar(`Esportazione completata`, '', {
              duration: 3000,
              panelClass: ['success-snackbar'],
            });
          }
        },
        error: (error) => {
          console.error(error);
          this.utilityService.openSnackBar(`Esportazione non riuscita`, '', {
            duration: 3000,
            panelClass: ['red-snackbar'],
          });
        },
      });
  }
}
